import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { HttpService } from "./http.service";
import { ToastrTranslateService } from "./toastr-translate.service";
import { UserRoleService } from "./user-role.service";

@Injectable({
  providedIn: "root",
})
export class DataService {
  public isFirstTimeLogIn: boolean = false;
  public isLoggedIn: boolean = false;
  public isVendor: boolean = false;
  private submenuSource = new BehaviorSubject("");
  openSubmenuItem = this.submenuSource.asObservable();

  private submenuSourceForBack = new BehaviorSubject("");
  submenuSourceForBackItem = this.submenuSourceForBack.asObservable();

  public pathVariable: any;
  public showScheduler: boolean = false;
  public schedulerShowId: any;
  private selectedPersonnel: any;
  public currentId: any;
  public lineFreze: any;
  public fromBooking: Boolean;

  private selectedReel = new BehaviorSubject(null);
  currentSelectedReel = this.selectedReel.asObservable();

  private dropDownValue = new BehaviorSubject(null);
  dropDownValueChange = this.dropDownValue.asObservable();

  constructor(private router: Router, private httpService: HttpService, private userRole: UserRoleService, private toastr: ToastrTranslateService) {}

  isUserLoggedIn = () => {
    return this.isLoggedIn;
  };

  isUserFirstTimeLogIn = () => {
    return this.isFirstTimeLogIn;
  };

  isVendorUser = () => {
    return this.isVendor;
  };

  logout() {
    localStorage.clear();

    this.userRole.logout();
    this.router.navigate(["signin"]).then(() => {
      console.log("reload called");
      document.location.reload();
    });
  }

  addPathvariables(pathVariable: any) {
    this.pathVariable = pathVariable;
  }

  saveEquipment(obj: any) {
    this.httpService.callApi("saveEquipment", { body: obj }).subscribe(
      (response) => {
        this.toastr.success("Successfully Saved", "Equipment");
      },
      (error) => {
        this.toastr.warning(error.error.message, "Equipment");
      }
    );
  }

  getSelectedPersonnel(personnelId: number, cb) {
    if (this.selectedPersonnel) {
      cb(this.selectedPersonnel);
    } else {
      this.httpService.callApi("getPersonalById", { pathVariable: "/" + personnelId }).subscribe(
        (response) => {
          this.selectedPersonnel = response;
          cb(this.selectedPersonnel);
        },
        (error) => {}
      );
    }
  }

  set setSelectedPersonnel(selectedPersonnel: any) {
    this.selectedPersonnel = selectedPersonnel;
  }

  changeReel(reel: any) {
    this.selectedReel.next(reel);
  }

  dropDownChange(value: any) {
    this.dropDownValue.next(value);
  }

  openSubmenu(message?: any) {
    this.submenuSource.next(message);
  }

  checkSubmenu(message?: any) {
    this.submenuSourceForBack.next(message);
  }
}
